import React from "react";
import NewTabulator from "../../NewTabulator/NewTabulator";
import { useState, useEffect } from "react";
import Select from "react-select";
import "./CounterFactorJoz.scss";
import {
  calculateSumOfEachRow,
  myCustomCelEditFunction,
  deleteRowHandler,
} from "../Functions";
import _axios from "../../../httpService";
import { toast } from "react-toastify";
import {
  parseToEnRemoveComma,
  formatToPersianAddComma,
} from "../../../utils/CommaSeparator";
import tableCalc from "../../../utils/tableCalc";

const CounterFactorJoz = ({
  sendData,
  setSendData,
  initialData,
  componentData,
  setComponentData,
}) => {
  const columnsTableOne = [
    { title: "کد کالا", field: "code" },
    { title: "عنوان کالا", field: "productName" },
    {
      title: "تعداد",
      field: "number",
      editor: "number",
      cellEdited: function (e, cell) {
        debugger;
        const value = parseToEnRemoveComma(e.target.value);
        // Remove any non-numeric characters
        const numericValue = value.replace(/[^0-9]/g, "");
        myCustomCelEditFunction(
          sendData,
          setSendData,
          cell,
          "number",
          numericValue,
          sendData?.productsTableData
        );
        debugger;
        const tableData = calculateSumOfEachRow(sendData?.productsTableData);
        setSendData({ productsTableData: tableData });
      },
      formatter: tableCalc.separateNumbers,
    },
    {
      title: "قیمت فروش",
      field: "price",
      editor: "number",
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value);
        // Remove any non-numeric characters
        const numericValue = value.replace(/[^0-9]/g, "");
        myCustomCelEditFunction(
          sendData,
          setSendData,
          cell,
          "price",
          numericValue,
          sendData?.productsTableData
        );
        // console.log(sendData.productsTableData);
        const tableData = calculateSumOfEachRow(sendData?.productsTableData);
        setSendData({ productsTableData: tableData });
      },
      formatter: tableCalc.separateNumbers,
    },
    { title: "جمع کل", field: "totalSum" },
    {
      title: "عملیات",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      style: {
        width: 200,
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItem: "center",
        justifyContent: "center",
      },
      cellClick: function (e, cell) {
        const productCode = cell.getData().code;
        const tableData = deleteRowHandler(
          sendData?.productsTableData,
          productCode
        );
        setSendData({ productsTableData: tableData });
      },
    },
  ];

  const columnsTableTwo = [
    { title: "عنوان خدمات", field: "serviceName" },
    { title: "id", field: "code", visible: false },
    {
      title: "تعداد",
      field: "number",
      editor: "number",
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value);
        // Remove any non-numeric characters
        const numericValue = value.replace(/[^0-9]/g, "");
        myCustomCelEditFunction(
          sendData,
          setSendData,
          cell,
          "number",
          numericValue,
          sendData.servicesTableData
        );
        const tableData = calculateSumOfEachRow(sendData.servicesTableData);
        setSendData({ servicesTableData: tableData });
      },
      formatter: tableCalc.separateNumbers,
    },
    {
      title: "قیمت فروش",
      field: "price",
      editor: "number",
      cellEdited: function (e, cell) {
        const value = parseToEnRemoveComma(e.target.value);
        // Remove any non-numeric characters
        const numericValue = value.replace(/[^0-9]/g, "");
        myCustomCelEditFunction(
          sendData,
          setSendData,
          cell,
          "price",
          numericValue,
          sendData.servicesTableData
        );
        const tableData = calculateSumOfEachRow(sendData.servicesTableData);
        setSendData({ servicesTableData: tableData });
      },
      formatter: tableCalc.separateNumbers,
    },
    { title: "جمع کل", field: "totalSum" },
    {
      title: "عملیات",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      style: {
        width: 200,
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItem: "center",
        justifyContent: "center",
      },
      cellClick: function (e, cell) {
        const serviceCode = cell.getData().code;
        const tableData = deleteRowHandler(
          sendData.servicesTableData,
          serviceCode
        );
        setSendData({ servicesTableData: tableData });
      },
    },
  ];

  const [selectedOption, setSelectedOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  useEffect(() => {
    // Filter options based on search text
    const filtered = initialData?.products.filter((option) =>
      option.label.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchText]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  const addNewRowToPriceTable = (inputObject, data) => {
    const objectData = { ...inputObject };
    // console.log(inputObject);
    //I know That productId is Uniq that backEnd Send to Front

    let tableData = [];
    let alreadyAdded = false;

    tableData =
      sendData?.productsTableData?.map((singleRow) => {
        if (+singleRow.code === +objectData.code) {
          singleRow.number = +singleRow.number + 1;
          alreadyAdded = true;
        }
        return singleRow;
      }) || [];

    if (!alreadyAdded) {
      tableData.push({ ...objectData });
    }
    tableData = calculateSumOfEachRow(tableData);
    setSendData({ productsTableData: tableData });
    // setComponentData({ reload: Math.random(), tableReload: Math.random() });

    // i will calculate sumPrice  of them in effect of show table Component
  };
  //function should be run when you clicked on a addBtnRow
  const addProductHandler = () => {
    if (selectedOption.value === "") {
      toast.error(`لطفا یک  کالا انتخاب کنید.`);
      return;
    }
    // console.log(`selectedProduct::${JSON.stringify(selectedOption)}`);

    //sample data
    const productData = {
      code: selectedOption?.value,
      productName: selectedOption?.label,
      number: selectedOption?.number,
      price: selectedOption?.price,
      recordId: "",
    };
    addNewRowToPriceTable(productData);
    setSelectedOption("");
  };

  //add new object to table

  // console.log(sendData?.productsTableData);
  useEffect(() => {
    const sum = sendData?.productsTableData?.reduce(function (total, row) {
      const newTotalSum = parseToEnRemoveComma(row.totalSum);
      const result = total + +newTotalSum;
      return result;
    }, 0);

    setComponentData({
      sumProductTotalInvoice: sum,
      reload: Math.random(),
    });
  }, [sendData?.productsTableData]);

  // ---------------- services part----------------

  //دیتای خدمات
  const [selectedServicesOption, setSelectedServicesOption] = useState(null); //خدمات انتخاب شده
  const [searchServicText, setSearchServiceText] = useState("");
  const [filteredServicesOptions, setFilteredServicesOptions] = useState([]); //اونهایی که مشابه اند رو بریز توی آرایه فیلتر

  //قابلیت سرچ خدمات
  useEffect(() => {
    // Filter options based on search text
    const filtered = initialData?.services.filter((option) =>
      option.label.toLowerCase().includes(searchServicText.toLowerCase())
    );
    setFilteredServicesOptions(filtered);
  }, [searchServicText]);

  //انتخاب کردن یکی از خدمات با select
  const servicehandleChange = (value) => {
    setSelectedServicesOption(value);
  };

  const addNewRowToServiceTable = (inputObject) => {
    const objectData = { ...inputObject };
    console.log(inputObject);
    //I know That productId is Uniq that backEnd Send to Front

    let tableData = [];
    let alreadyAdded = false;

    tableData =
      sendData?.servicesTableData?.map((singleRow) => {
        if (+singleRow.code === +objectData.code) {
          singleRow.number = +singleRow.number + 1;
          alreadyAdded = true;
        }
        return singleRow;
      }) || [];

    if (!alreadyAdded) {
      tableData.push({ ...objectData });
    }
    tableData = calculateSumOfEachRow(tableData);
    setSendData({ servicesTableData: tableData });
    // i will calculate sumPrice  of them in effect of show table Component
  };
  //function should be run when you clicked on a addBtnRow
  const addServiceHandler = () => {
    if (selectedServicesOption.value === "") {
      toast.error(`لطفا یک  کالا انتخاب کنید.`);
      return;
    }
    // console.log(`selectedProduct::${JSON.stringify(selectedOption)}`);

    //sample data
    const serviceData = {
      code: selectedServicesOption?.value,
      serviceName: selectedServicesOption?.label,
      number: selectedServicesOption?.number,
      price: selectedServicesOption?.price,
      recordId: "",
    };
    addNewRowToServiceTable(serviceData);
    setSelectedServicesOption("");
  };

  //add new object to table
  useEffect(() => {
    const sum = sendData?.servicesTableData?.reduce(function (total, row) {
      const newTotalSum = parseToEnRemoveComma(row.totalSum);
      const result = total + +newTotalSum;
      return result;
    }, 0);
    setComponentData({
      sumServiceTotalInvoice: sum,
      reload: Math.random(),
    });
  }, [sendData?.servicesTableData]);

  const numberChangeHandler = (e, data) => {
    // Remove any non-numeric characters
    const enteredValue = parseToEnRemoveComma(e.target.value);
    const numericValue = enteredValue.replace(/[^0-9]/g, "");
    const items = [...sendData?.productsTableData];
    const newItems = items.map((v) => {
      const temp = { ...v };
      if (+temp.code === +data.code) {
        temp.number = numericValue;
      }
      return temp;
    });
    const tableData = calculateSumOfEachRow(newItems);
    setSendData({ productsTableData: tableData });
  };

  const priceChangeHandler = (e, data) => {
    // Remove any non-numeric characters
    const enteredValue = parseToEnRemoveComma(e.target.value);
    const numericValue = enteredValue.replace(/[^0-9]/g, "");
    const items = [...sendData?.productsTableData];
    const newItems = items.map((v) => {
      const temp = { ...v };
      if (+temp.code === +data.code) {
        temp.price = numericValue;
      }
      return temp;
    });

    const tableData = calculateSumOfEachRow(newItems);
    setSendData({ productsTableData: tableData });
  };

  const numberChangeHandlerService = (e, data) => {
    // Remove any non-numeric characters
    const enteredValue = parseToEnRemoveComma(e.target.value);
    const numericValue = enteredValue.replace(/[^0-9]/g, "");
    const items = [...sendData?.servicesTableData];
    const newItems = items.map((v) => {
      const temp = { ...v };
      if (+temp.code === +data.code) {
        temp.number = numericValue;
      }
      return temp;
    });
    const tableData = calculateSumOfEachRow(newItems);
    setSendData({ servicesTableData: tableData });
  };

  const priceChangeHandlerService = (e, data) => {
    // Remove any non-numeric characters
    const enteredValue = parseToEnRemoveComma(e.target.value);
    const numericValue = enteredValue.replace(/[^0-9]/g, "");
    const items = [...sendData?.servicesTableData];
    const newItems = items.map((v) => {
      const temp = { ...v };
      if (+temp.code === +data.code) {
        temp.price = numericValue;
      }
      return temp;
    });

    const tableData = calculateSumOfEachRow(newItems);
    setSendData({ servicesTableData: tableData });
  };

  return (
    <div className="tables__wrapper">
      <div id="print-section" className="Factor-table">
        <div className="searchboxPrnt__">
          <div className="searchBox__">
            <label>نام کالا</label>
            <Select
              value={selectedOption}
              onChange={handleChange}
              options={filteredOptions}
              onInputChange={(inputValue) => setSearchText(inputValue)}
              isSearchable={true}
              placeholder="نام کالا را انتخاب کنید"
            />
          </div>
          <button className="addRowBtn_" onClick={addProductHandler}>
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.3333 12.2188H7.66667C7.27376 12.2188 6.94792 11.8929 6.94792 11.5C6.94792 11.1071 7.27376 10.7812 7.66667 10.7812H15.3333C15.7263 10.7812 16.0521 11.1071 16.0521 11.5C16.0521 11.8929 15.7263 12.2188 15.3333 12.2188Z"
                fill="white"
              />
              <path
                d="M11.5 16.0521C11.1071 16.0521 10.7812 15.7263 10.7812 15.3334V7.66669C10.7812 7.27377 11.1071 6.94794 11.5 6.94794C11.8929 6.94794 12.2188 7.27377 12.2188 7.66669V15.3334C12.2188 15.7263 11.8929 16.0521 11.5 16.0521Z"
                fill="white"
              />
              <path
                d="M14.375 21.8021H8.625C3.42126 21.8021 1.19792 19.5788 1.19792 14.375V8.62502C1.19792 3.42127 3.42126 1.19794 8.625 1.19794H14.375C19.5788 1.19794 21.8021 3.42127 21.8021 8.62502V14.375C21.8021 19.5788 19.5788 21.8021 14.375 21.8021ZM8.625 2.63544C4.20709 2.63544 2.63542 4.2071 2.63542 8.62502V14.375C2.63542 18.7929 4.20709 20.3646 8.625 20.3646H14.375C18.7929 20.3646 20.3646 18.7929 20.3646 14.375V8.62502C20.3646 4.2071 18.7929 2.63544 14.375 2.63544H8.625Z"
                fill="white"
              />
            </svg>
          </button>
        </div>

        <div className="table_box_prnt">
          <div className="table_box">
            <NewTabulator
              columns={columnsTableOne}
              // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }
              data={sendData?.productsTableData}
              // options={TabulatorTableOptions.style3}
              style={{ height: "50vh", overflowY: "scroll" }}
              className={"header__color__F1F1F1 newTabulator_height"}
            />
            {sendData?.productsTableData?.map((v, index) => {
              return (
                <ul
                  className="responsive_table_records_parent"
                  key={"OCFG" + index}
                  id={v?.code}
                >
                  <li>
                    <span className="res_table_title">کد کالا</span>
                    <span className="res_table_data" name="productCode">
                      {v?.code}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">نام مواد اولیه</span>
                    <span className="res_table_data" name="nameMaterial">
                      {v?.productName}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">تعداد</span>
                    <input
                      className="res_table_data"
                      name="number"
                      value={formatToPersianAddComma(v?.number)}
                      onChange={(e) => numberChangeHandler(e, v)}
                    />
                  </li>
                  <li>
                    <span className="res_table_title">قیمت فروش</span>
                    <input
                      className="res_table_data"
                      name="price"
                      value={formatToPersianAddComma(v?.price)}
                      type="text"
                      onChange={(e) => priceChangeHandler(e, v)}
                    />
                  </li>
                  <li>
                    <span className="res_table_title">جمع کل</span>
                    <span className="res_table_data" name="totalSum">
                      {v?.totalSum}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">عملیات</span>
                    <span
                      className="res_table_data"
                      onClick={(e) => {
                        const tableData = deleteRowHandler(
                          sendData?.productsTableData,
                          v?.code
                        );
                        setSendData({ productsTableData: tableData });
                      }}
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.99" clip-path="url(#clip0_567_6922)">
                          <path
                            d="M15.183 16.2435L6.6977 7.75823C6.40778 7.46831 6.40778 6.98748 6.6977 6.69757C6.98761 6.40765 7.46844 6.40765 7.75836 6.69757L16.2436 15.1828C16.5336 15.4728 16.5336 15.9536 16.2436 16.2435C15.9537 16.5334 15.4729 16.5334 15.183 16.2435Z"
                            fill="#F84459"
                          />
                          <path
                            d="M6.69752 16.2435C6.40761 15.9536 6.40761 15.4728 6.69752 15.1828L15.1828 6.69757C15.4727 6.40765 15.9536 6.40765 16.2435 6.69757C16.5334 6.98748 16.5334 7.46831 16.2435 7.75823L7.75818 16.2435C7.46827 16.5334 6.98744 16.5334 6.69752 16.2435Z"
                            fill="#F84459"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_567_6922">
                            <rect
                              width="15.5563"
                              height="15.5563"
                              fill="white"
                              transform="translate(11) rotate(45)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </li>
                </ul>
              );
            })}
            <div className="line__"></div>
          </div>
          <div className="totalSumOfTable__">
            <span className="totalText_">جمع فاکتور کالا </span>
            <span className="totalPrice_">
              {formatToPersianAddComma(componentData?.sumProductTotalInvoice)}{" "}
              ریال
            </span>
          </div>
        </div>
      </div>

      {/* seconde table*/}
      <div id="print-section-two" className="Factor-table">
        <div className="searchboxPrnt__">
          <div className="searchBox__">
            <label>خدمات</label>
            <Select
              value={selectedServicesOption}
              onChange={servicehandleChange}
              options={filteredServicesOptions}
              onInputChange={(inputValue) => setSearchServiceText(inputValue)}
              isSearchable={true}
              placeholder="خدمات مورد نظر را انتخاب کنید"
            />
          </div>
          <button className="addRowBtn_" onClick={addServiceHandler}>
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.3333 12.2188H7.66667C7.27376 12.2188 6.94792 11.8929 6.94792 11.5C6.94792 11.1071 7.27376 10.7812 7.66667 10.7812H15.3333C15.7263 10.7812 16.0521 11.1071 16.0521 11.5C16.0521 11.8929 15.7263 12.2188 15.3333 12.2188Z"
                fill="white"
              />
              <path
                d="M11.5 16.0521C11.1071 16.0521 10.7812 15.7263 10.7812 15.3334V7.66669C10.7812 7.27377 11.1071 6.94794 11.5 6.94794C11.8929 6.94794 12.2188 7.27377 12.2188 7.66669V15.3334C12.2188 15.7263 11.8929 16.0521 11.5 16.0521Z"
                fill="white"
              />
              <path
                d="M14.375 21.8021H8.625C3.42126 21.8021 1.19792 19.5788 1.19792 14.375V8.62502C1.19792 3.42127 3.42126 1.19794 8.625 1.19794H14.375C19.5788 1.19794 21.8021 3.42127 21.8021 8.62502V14.375C21.8021 19.5788 19.5788 21.8021 14.375 21.8021ZM8.625 2.63544C4.20709 2.63544 2.63542 4.2071 2.63542 8.62502V14.375C2.63542 18.7929 4.20709 20.3646 8.625 20.3646H14.375C18.7929 20.3646 20.3646 18.7929 20.3646 14.375V8.62502C20.3646 4.2071 18.7929 2.63544 14.375 2.63544H8.625Z"
                fill="white"
              />
            </svg>
          </button>
        </div>

        <div className="table_box_prnt">
          <div className="table_box">
            <NewTabulator
              columns={columnsTableTwo}
              // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }
              data={sendData?.servicesTableData}
              // options={TabulatorTableOptions.style3}
              style={{ height: "50vh", overflowY: "scroll" }}
              className={"header__color__F1F1F1 newTabulator_height"}
            />
            {sendData?.servicesTableData?.map((v, index) => {
              return (
                <ul
                  className="responsive_table_records_parent"
                  key={"OCFG" + index}
                  id={v?.code}
                >
                  <li>
                    <span className="res_table_title">کد کالا</span>
                    <span className="res_table_data" name="code">
                      {v?.code}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">عنوان کالا</span>
                    <span className="res_table_data" name="productName">
                      {v?.serviceName}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">تعداد</span>
                    <input
                      className="res_table_data"
                      name="number"
                      value={formatToPersianAddComma(v?.number)}
                      onChange={(e) => numberChangeHandlerService(e, v)}
                    />
                  </li>
                  <li>
                    <span className="res_table_title">قیمت فروش</span>
                    <input
                      className="res_table_data"
                      name="price"
                      value={formatToPersianAddComma(v?.price)}
                      type="text"
                      onChange={(e) => priceChangeHandlerService(e, v)}
                    />
                  </li>
                  <li>
                    <span className="res_table_title">جمع کل</span>
                    <span className="res_table_data" name="totalSum">
                      {v?.totalSum}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">عملیات</span>
                    <span
                      className="res_table_data"
                      onClick={(e) => {
                        const tableData = deleteRowHandler(
                          sendData?.servicesTableData,
                          v?.code
                        );
                        setSendData({ servicesTableData: tableData });
                      }}
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.99" clip-path="url(#clip0_567_6922)">
                          <path
                            d="M15.183 16.2435L6.6977 7.75823C6.40778 7.46831 6.40778 6.98748 6.6977 6.69757C6.98761 6.40765 7.46844 6.40765 7.75836 6.69757L16.2436 15.1828C16.5336 15.4728 16.5336 15.9536 16.2436 16.2435C15.9537 16.5334 15.4729 16.5334 15.183 16.2435Z"
                            fill="#F84459"
                          />
                          <path
                            d="M6.69752 16.2435C6.40761 15.9536 6.40761 15.4728 6.69752 15.1828L15.1828 6.69757C15.4727 6.40765 15.9536 6.40765 16.2435 6.69757C16.5334 6.98748 16.5334 7.46831 16.2435 7.75823L7.75818 16.2435C7.46827 16.5334 6.98744 16.5334 6.69752 16.2435Z"
                            fill="#F84459"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_567_6922">
                            <rect
                              width="15.5563"
                              height="15.5563"
                              fill="white"
                              transform="translate(11) rotate(45)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </li>
                </ul>
              );
            })}
            <div className="line__"></div>
          </div>
          <div className="totalSumOfTable__">
            <span className="totalText_">جمع فاکتور خدمات</span>
            <span className="totalPrice_">
              {formatToPersianAddComma(componentData?.sumServiceTotalInvoice)}{" "}
              ریال
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterFactorJoz;
